const state = {
  order: null
}

const getters = {
  orderStateMachine: state => {
    return state.order
  }
}

const mutations = {
  SET_ORDER_SM (state, sm) {
    state.order = sm
  }
}

const actions = {
  setOrderStateMachine ({ state, commit }, sm) {
    commit('SET_ORDER_SM', sm)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
